export default {"src":"/_next/static/media/ethos.bc7f3429.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};